/**
 * Profile — user info and pack stats
 */
import { useState, useEffect } from 'react';
import { fetchJson } from './api.js';

export default function ProfileView() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJson('/api/me')
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="gallery-loading">Loading...</div>;
  if (!user) return <div className="coming-soon"><p>Log in to see your profile.</p></div>;

  return (
    <div className="profile-view">
      <h1>Profile</h1>
      <div className="profile-card">
        <p><strong>{user.username}</strong></p>
        {user.isAdmin && <span className="admin-badge">Admin</span>}
      </div>
    </div>
  );
}
